<template>
  <b-row class="match-height">
    <b-col lg="12">
      <b-card title="Item Disposal Detail">
        <b-row>
          <b-col cols="12">
            <b-button
              type="button"
              variant="primary"
              class="mr-1"
              @click="previous()"
            >
              <feather-icon
                icon="ArrowLeftIcon"
                size="16"
                class="align-middle"
              />
              Back
            </b-button>
            <b-button
              type="button"
              variant="primary"
              class="mr-1 float-rigth"
              @click="print()"
            >
              <feather-icon
icon="PrinterIcon"
size="16"
class="align-middle"
/>
              Print
            </b-button>
            <b-button
              v-if="itemdisposalIsReceived === 'Yes'"
              type="button"
              variant="primary"
              class="mr-1 float-rigth"
              @click="deliveryConfirmation()"
            >
              <feather-icon
icon="PrinterIcon"
size="16"
class="align-middle"
/>
              Delivery Confirmation
            </b-button>
            <div class="devider" />
            <b-form-group>
              <label for="email">Number :</label>
              <input
                v-model="itemDisposalNumber"
                type="text"
                name="Number"
                class="form-control"
                readonly
              >
            </b-form-group>
            <b-form-group>
              <label for="email">Notes :</label>
              <input
                v-model="itemDisposalNotes"
                type="text"
                name="to"
                class="form-control"
                readonly
              >
            </b-form-group>
            <b-form-group>
              <label for="no_invoice">Items :</label>
            </b-form-group>
            <b-form-group>
              <br>
              <div>
                <b-row>
                  <b-col
cols="8"
class="text-center font-weight-bold"
>
                    Item name
                  </b-col>
                  <b-col
cols="2"
class="text-center font-weight-bold"
>
                    Item Unit
                  </b-col>
                  <b-col
cols="2"
class="text-center font-weight-bold"
>
                   QTY
                  </b-col>
                </b-row>

                <b-row
                  v-for="item in items"
                  :key="item.item_disposal_detail_item_id"
                >
                  <br>
                  <b-col
cols="8"
class="text-center"
>
                    <b-list-group>
                      <b-list-group-item
                        href="#"
                      >
                        {{ item.item.item_name }} ({{ item.item.item_code }})
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                  <b-col
cols="2"
class="text-center"
>
                    <b-list-group>
                      <b-list-group-item href="#">
                        {{
                          item.item.unit
                            ? capitalizeWords(item.item.unit.unit_name)
                            : "-"
                        }}
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                  <b-col
cols="2"
class="text-center"
>
                    <b-list-group>
                      <b-list-group-item href="#">
                        {{
                          item.item_disposal_detail_item_qty
                        }}
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                  <b-col cols="12">
                    <br>
                  </b-col>
                </b-row>
                <p />
              </div>
            </b-form-group>
            <b-form-group>
              <label for="no_invoice">Status :</label>
              <vue-horizontal-timeline :items="statusItems" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import axios from "axios"
import moment from "moment-timezone"
import Ripple from "vue-ripple-directive"
import { VueHorizontalTimeline } from "vue-horizontal-timeline"
import { ref } from "@vue/composition-api"
import apiEndpoints from '@/constants/apiEndpoints'

const VersionCheck = ""
const items = []
const chosenItem = ref(3)
const chosens = []
const statusItems = []
const itemDisposalNotes = ""
const itemDisposalCc = ""
const itemDisposalReason = ""
const itemDisposalQtyRequested = 0
const itemDisposalStatus = ""
const itemDisposalId = ""
const itemDisposalNumber = ""
const itemDisposalType = ""
const itemdisposalIsAcceptedBySupervisor = 0
const itemdisposalIsAcceptedByWarehouse = 0
const itemdisposalIsReceived = 'No'
const apiUrl = process.env.VUE_APP_API_URL
export default {
  components: {
    VueHorizontalTimeline,
    BListGroup,
    BListGroupItem,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      statusItems,
      VersionCheck,
      items,
      chosenItem,
      chosens,
      itemDisposalNotes,
      itemDisposalCc,
      itemDisposalReason,
      itemDisposalQtyRequested,
      itemDisposalStatus,
      itemDisposalId,
      itemDisposalNumber,
      itemdisposalIsAcceptedBySupervisor,
      itemdisposalIsAcceptedByWarehouse,
      itemdisposalIsReceived,
      itemDisposalType,
      apiUrl,
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }
      const item = JSON.parse(localStorage.getItem("itemDisposalDetail"))
      this.modalDetailShow = true
      this.itemDisposalNotes = item.item_disposal_notes
      this.itemDisposalNumber = item.item_disposal_number
      const id = item.item_disposal_id
      const obj1 = {
        title: "Created",
        content: `Item Disposal Has been Created By ${
          item.requester.user_fullname
        } at ${this.dateSimple(
          item.item_disposal_created_time,
          "YYYY-MM-DD",
        )}`,
        stepCssClass: "has-step-green",
        boxCssClass: "has-color-red",
      }
      const obj2 = {
        title: "Laboratory Manager",
        content:
          item.item_disposal_confirmed_by !== null
            ? `Item Disposal Has been Accepted by ${
                item.lab_manager.user_fullname
              } at ${this.dateSimple(
                item.item_disposal_is_accepted_by_supervisor_date,
                "YYYY-MM-DD",
              )}`
            : `Item Disposal Has not been Accepted By Laboratory Manger`,
        stepCssClass:
          item.item_disposal_is_accepted_by_supervisor === true
            ? "has-step-green"
            : "has-step-red",
      }
      this.statusItems = []
      this.statusItems.push(obj1)
      this.statusItems.push(obj2)
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DETAIL_ITEM_DISPOSALS}${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            this.items = response.data.data
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fetching Data success",
                icon: "CheckIcon",
                variant: "success",
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Fetching Data failed",
                icon: "CheckIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    deliveryConfirmation() {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }
      const id = this.itemDisposalId
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_ITEM_DISPOSAL_DELIVERY_CONFIRMATION}${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            const url = `${process.env.VUE_APP_API_URL}temp/${response.data.data}`
            window.open(url, "_blank")
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Download Data failed",
                icon: "CheckIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    print() {
      const userToken = this.$cookies.get("userToken")
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      }

      const item = JSON.parse(localStorage.getItem("itemDisposalDetail"))
      const id = item.item_disposal_id
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DOWNLOAD_ITEM_DISPOSALS}${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            const url = `${process.env.VUE_APP_API_URL}temp/${response.data.data}`
            window.open(url, "_blank")
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Download Data failed",
                icon: "CheckIcon",
                variant: "danger",
              },
            })
          }
        })
    },
    getOptionLabel(option) {
      return (option && option.label) || ""
    },
    putItem(val) {
      if (this.chosens.length > 0) {
        let same = false
        this.chosens.map(elem => {
          if (elem.value === val.value) {
            same = true
          }
        })
        if (same === false) {
          let item = null
          this.items.map(elem => {
            if (elem.value === val.value) {
              item = { label: elem.label, value: elem.value, qty: 1 }
            }
          })
          this.chosens.push(item)
        }
      } else {
        let item = null
        this.items.map(elem => {
          if (elem.value === val.value) {
            item = { label: elem.label, value: elem.value, qty: 1 }
          }
        })

        this.chosens.push(item)
      }
    },
    applyItem(val) {

    },
    getOptionKey(option) {
      return (option && option.value) || ""
    },
    inputSearch(search) {

    },
    removeRow(val) {
      this.chosens = this.chosens.filter(obj => obj.value !== val)
    },
    dateFormat(value, format = "MM/DD/YYYY") {
      return moment.utc(value).tz('Asia/Jakarta').format(format)
    },
    dateSimple(value, format = "YYYY-MM-DD") {
      let dateRet = ""
      if (value !== null) {
        dateRet = moment.utc(value).tz('Asia/Jakarta').format(format)
      } else {
        dateRet = null
      }
      return dateRet
    },
    previous() {
      this.$router.push({ name: "apps-material-request-list" })
    },
    getFullUrl(picturePath) {
      return `${this.apiUrl}/upload/${picturePath}`
    },
    capitalizeWords(str) {
      // Split the string into words using spaces as the separator
      const words = str.split(" ")
      // Capitalize the first letter of each word and join them back together
      const capitalizedWords = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      // Join the capitalized words into a single string with spaces
      return capitalizedWords.join(" ")
    },
  },
}
</script>
